import { Button, Menu, MenuContent, MenuRadioGroup, MenuRadioItem, MenuTrigger } from '@cad-arc';
import { adaptSelectOnChange } from '../../forms/helpers/adapt-select-on-change';
import { Option } from '../../forms/option';

export function SortMenu<T extends string>({
    value,
    onChange,
    options,
}: {
    value: Option<T>;
    onChange: (value: Option<T>) => void;
    options: Option<T>[];
}): React.ReactElement {
    return (
        <Menu>
            <MenuTrigger asChild>
                <Button variant="ghost" trailingVisual="Open">
                    Sort: {value.label}
                </Button>
            </MenuTrigger>
            <MenuContent>
                <MenuRadioGroup
                    title="Direction"
                    value={value.value}
                    onValueChange={(value) =>
                        adaptSelectOnChange(
                            (e) => onChange(e.target.value),
                            options
                        )({ target: { value } })
                    }
                >
                    {options.map((option) => (
                        <MenuRadioItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuRadioItem>
                    ))}
                </MenuRadioGroup>
            </MenuContent>
        </Menu>
    );
}
